// @ts-nocheck

import { createSelector } from 'reselect';

import { getLang } from '../../../i18n/l10n';
import { selectRuntimeLicence } from '../../../selectors/runtime/runtimePrimary.selector';
import { Licences, Locales } from '../../../types/common';
import { type Selector } from '../../../types/selectors';
import { KLVersion } from '../constants/meta';
import { KLGlobalStatuses } from '../types/global';
import { KLUserStatuses } from '../types/user';

import { selectKLGlobalStatus, selectKLGlobalVersion } from './global';
import { selectKLUserStatus } from './user';

export const selectIsKLEnabled: Selector<boolean> = createSelector(
  [selectKLGlobalStatus, selectKLGlobalVersion, selectKLUserStatus, selectRuntimeLicence],
  (globalStatus, version, userStatus, license) =>
    // false /* Forcing deactivation */ &&
    (globalStatus === KLGlobalStatuses.RUNNING || globalStatus === KLGlobalStatuses.ENDING) &&
    version === KLVersion &&
    license === Licences.FR &&
    getLang() === Locales.FR &&
    userStatus !== KLUserStatuses.EXCLUDED,
);

export const selectIsKLPlayable: Selector<boolean> = createSelector(
  [selectIsKLEnabled, selectKLGlobalStatus],
  (isKLEnabled, globalStatus) => globalStatus === KLGlobalStatuses.RUNNING && isKLEnabled,
);
